import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  ShowButton,
  DeleteButton,
  SearchInput,
  FilterButton,
  CreateButton,
  TopToolbar,
  ExportButton,
  BooleanField,
  useListContext,
  useNotify,
  useRefresh,
  useRedirect,
} from 'react-admin';
import { Box, Typography, Alert } from '@mui/material';
import { useEffect, useState } from 'react';

const NotificationFilters = [
  <SearchInput source="q" placeholder="Search tokens..." alwaysOn key="q" />,
  <SearchInput source="userId" placeholder="User ID" key="userId" />,
  <SearchInput source="device" placeholder="Device type" key="device" />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const NotificationList = (props: any) => {
  const [error, setError] = useState<string | null>(null);
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  // Custom error boundary for the list
  useEffect(() => {
    // Listen for global fetch errors (react-admin will call onFailure)
    const handleError = (e: any) => {
      setError(
        'Notifications API is not available yet. This feature will be enabled once the backend is ready.'
      );
    };
    window.addEventListener('unhandledrejection', handleError);
    return () => window.removeEventListener('unhandledrejection', handleError);
  }, []);

  return (
    <Box>
      {error && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <List
        {...props}
        filters={NotificationFilters}
        actions={<ListActions />}
        perPage={25}
        sort={{ field: 'createdAt', order: 'DESC' }}
        // If error, disable fetching
        disableSyncWithLocation={!!error}
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="id" label="Token ID" />
          <TextField source="token" label="FCM Token" />
          <TextField source="userId" label="User ID" />
          <TextField source="device" label="Device" />
          <BooleanField source="isActive" label="Active" />
          <DateField source="createdAt" label="Created At" showTime />
          <DateField source="updatedAt" label="Updated At" showTime />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <ShowButton />
            <EditButton />
            <DeleteButton />
          </Box>
        </Datagrid>
      </List>
    </Box>
  );
};

export default NotificationList; 